export default {
    name: 'SymplaTokens'
}
